import React from 'react';

const OfflineOverlay = () => {
    return (
        <div className="fixed inset-0 z-[1000] bg-black flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-500">
            {/* Pulsing Glow Background */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-red-600/20 blur-[100px] rounded-full animate-pulse"></div>
            
            <div className="relative z-10 flex flex-col items-center">
                <div className="w-24 h-24 bg-zinc-900 rounded-[2rem] flex items-center justify-center mb-8 border border-white/5 shadow-2xl relative overflow-hidden group">
                    <span className="text-5xl group-hover:scale-110 transition-transform duration-500">📡</span>
                    <div className="absolute inset-0 bg-red-600/10 animate-pulse"></div>
                </div>

                <h1 className="text-3xl font-black italic uppercase tracking-tighter text-white mb-4">
                    Connection <span className="text-red-500">Lost!</span>
                </h1>

                <p className="text-gray-400 text-sm font-medium max-w-[260px] leading-relaxed mb-10 uppercase tracking-widest">
                    Oops! It looks like your internet decided to take a break. Please check your connection.
                </p>

                <button 
                    onClick={() => window.location.reload()}
                    className="w-full max-w-[240px] bg-white text-black py-4 rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-xl hover:bg-red-500 hover:text-white transition-all active:scale-95 flex items-center justify-center gap-3 border-b-4 border-zinc-200 active:border-b-0 active:translate-y-1"
                >
                    <span>🔄 Retry Connection</span>
                </button>

                <div className="mt-8 flex items-center gap-2 opacity-30">
                    <div className="w-1.5 h-1.5 bg-red-500 rounded-full animate-ping"></div>
                    <span className="text-[10px] font-black text-white uppercase tracking-widest">Waiting for Network...</span>
                </div>
            </div>

            {/* Bottom Branding */}
            <div className="absolute bottom-10 left-0 right-0 text-center opacity-10">
                <h2 className="text-2xl font-black italic tracking-tighter uppercase text-white">WinroX11</h2>
            </div>
        </div>
    );
};

export default OfflineOverlay;
